// descontos-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "- Clientes": "- Clientes",
    "Ativar notificação": "Activar notificación",
    "Cadastrar desconto": "Registrar descuento",
    "Clientes Elegíveis": "Clientes Elegibles",
    "Clientes selecionados": "Clientes seleccionados",
    "Clique em um dos cartões abaixo para escolher como este desconto será aplicado. Cada tipo tem comportamentos e configurações diferentes.": "Haga clic en una de las tarjetas de abajo para elegir cómo se aplicará este descuento. Cada tipo tiene comportamientos y configuraciones diferentes.",
    "Custo": "Costo",
    "Desativado em": "Desactivado en",
    "Desconto criado com sucesso": "Descuento creado con éxito",
    "Desconto disponível para todos os clientes": "Descuento disponible para todos los clientes",
    "Descontos por combustíveis": "Descuentos por combustibles",
    "Enviar via:": "Enviar vía:",
    "Envio agora": "Envío ahora",
    "Envio às": "Envío a las",
    "Especial": "Especial",
    "Este desconto não possui restrições de segmentação por grupos ou tags de clientes, portanto está disponível para todos os clientes da rede.": "Este descuento no posee restricciones de segmentación por grupos o etiquetas de clientes, por lo que está disponible para todos los clientes de la red.",
    "Etiquetas de clientes": "Etiquetas de clientes",
    "Grupos": "Grupos",
    "Hora de início": "Hora de inicio",
    "Há": "Hay",
    "Intervalo de uso (horas)": "Intervalo de uso (horas)",
    "Intervalo entre usos": "Intervalo entre usos",
    "Limite de uso": "Límite de uso",
    "Limites de Uso": "Límites de Uso",
    "Manual de Descontos": "Manual de Descuentos",
    "Messagem Push": "Mensaje Push",
    "Messagem SMS": "Mensaje SMS",
    "Nenhum cliente encontrado com a segmentação definida para este desconto": "No se encontraron clientes con la segmentación definida para este descuento",
    "Nenhuma segmentação configurada (disponível para todos)": "Ninguna segmentación configurada (disponible para todos)",
    "Notificação no aplicativo": "Notificación en la aplicación",
    "Notificações": "Notificaciones",
    "OU": "O",
    "Pontua quando usado": "Puntúa cuando se usa",
    "Pontuar ao usar desconto": "Puntuar al usar descuento",
    "Postos (": "Estaciones (",
    "Recompensa": "Recompensa",
    "Se desabilitado, o cliente NÃO ganhará pontos ao usar este desconto": "Si está deshabilitado, el cliente NO ganará puntos al usar este descuento",
    "Se você continuar, os postos abaixo serão desvinculados de seus respectivos descontos e incorporados ao desconto em criação. Porém os descontos antigos ainda ficaram ativos em relação ao seus demais postos.": "Si continúa, las estaciones de abajo serán desvinculadas de sus respectivos descuentos e incorporadas al descuento en creación. Sin embargo, los descuentos anteriores seguirán activos en relación con sus demás estaciones.",
    "Selecione grupos de clientes e/ou tags para aplicar o desconto": "Seleccione grupos de clientes y/o etiquetas para aplicar el descuento",
    "Selecione o tipo de desconto": "Seleccione el tipo de descuento",
    "Sem cidades": "Sin ciudades",
    "Sem notificações": "Sin notificaciones",
    "Sem tag": "Sin etiqueta",
    "Sobrepor o desconto padrão": "Sobrescribir el descuento predeterminado",
    "Tags": "Etiquetas",
    "Um ou mais postos selecionados possuem": "Una o más estaciones seleccionadas poseen",
    "Validade em dias": "Validez en días",
    "clientes selecionados pra esse desconto": "clientes seleccionados para este descuento",
    "desconto fixo": "descuento fijo",
    "hora": "hora",
    "vinculado": "vinculado",
};

export default catalogo;
